import { Store } from '..';

export const selectCallsQueue = (state: Store) => state.call.queue;
export const selectCurrentCall = (state: Store) => state.call.currentCall;
export const selectIsAccepting = (state: Store) => state.call.isAccepting;
export const selectAcceptingCallId = (state: Store) => state.call.acceptingCallId;
export const selectIsEnding = (state: Store) => state.call.isEnding;
